import * as React from 'react';
import createSvgIcon from '../utils/createSvgIcon';

const Curbside = createSvgIcon(
  <path d="M21,3h-3.5l-3.3,5.2h3.4c1,0,1.9,0.8,1.9,1.9v7.1l-2,3H15c-0.2,1.9-1.9,3.2-3.7,3c-1.6-0.2-2.8-1.4-3-3H3V18h5.8c0.6-0.9,1.7-1.5,2.8-1.5c1.2,0,2.2,0.6,2.8,1.5h1.8l1-1.5v-6h-4.3l-4.1-6H3V2.3h7l2.8,4.1l2.9-4.7c0.3-0.5,0.9-0.9,1.6-0.9H21V3z" />,
  'Curbside'
);

export { Curbside };